import { Plus } from 'lucide-react';
import { Button } from '@sara/ui/components/button';
import { useDialog } from '@sara/ui/hooks/use-dialog';
import { useActiveOrganization } from '../../contexts/auth';
import { ApiKeyListContainer, CreateApiKeyDialog } from '../../contexts/api-keys';
import { PageHeader } from '../../components/page-header';

export function ApiKeysSettingsPage() {
  const { organization } = useActiveOrganization();
  const createDialog = useDialog(CreateApiKeyDialog);

  return (
    <div className="space-y-12">
      <PageHeader
        title="API keys"
        description="Authenticate requests from your own services to the AI Interviewer API. Each key is shown once on creation — store it somewhere safe."
        action={
          organization && (
            <Button
              variant="tinted"
              shape="pill"
              size="sm"
              className="h-8 gap-1.5 px-3 text-xs [&_svg]:size-3.5 sm:h-9 sm:px-4 sm:text-sm sm:[&_svg]:size-4"
              onClick={() => createDialog.open({ orgId: organization.id })}
            >
              <Plus strokeWidth={1.6} />
              New API key
            </Button>
          )
        }
      />

      <section>{organization && <ApiKeyListContainer orgId={organization.id} />}</section>
    </div>
  );
}
